import dynamic from 'next/dynamic'
import Head from 'next/head'
import StoneleighHeader from '../../../components/StoneleighHeader';
import Image from "next/legacy/image";
import CTA from '../../../components/CTA';
import YoastSEO from '../../../components/YoastSEO';
import { useEffect, useState } from 'react';

import { client } from '../../../lib/apollo';
import { GET_HEADER_OPTIONS, GET_FOOTER_OPTIONS, GET_PLANT_OPTIONS, 
    GET_PLANT_ATTRIBUTES, GET_PLANT_TYPES, GET_PLANTS, SEARCH_PLANTS } from '../../../queries/queries';

import Script from 'next/script'
import { RouteChangeListener } from '../../../components/OptinMonsterEmbed';

const DynamicFooterStoneleigh = dynamic(() => import('../../../components/StoneleighFooter'))

export default function PlantsPage({pageData}) {
const headerData = pageData?.headerData;
const footerData = pageData?.footerData;
const plantAttributes = pageData?.plantAttributes?.data?.allPlantAttribute?.nodes;
const plantTypes = pageData?.plantTypes?.data?.allPlantTypes?.nodes;
const cta = pageData?.plantOptions?.data?.siteOptions?.plantOptions?.plantCta[0];
const headerSubtitle = pageData?.plantOptions?.data?.siteOptions?.plantOptions?.plantHeaderContent;
const seoData = pageData.plantSeo.data.seo.contentTypes.plants.archive;

const [plants, setPlants] = useState([]);
const [plantTypeSlug, setPlantTypeSlug] = useState('all');
const [plantAttributeSlug, setPlantAttributeSlug] = useState('all');
const [originalPlants, setOriginalPlants] = useState([])
const [searchValue, setSearchValue] = useState('');

const plantSearch = (event) => {
  if (event.keyCode === 13){
    window.location.href = '/stoneleigh/plants/?search=' + event.target.value;
  }
}

const typeOnChange = (event) => {
  const selectedValue = event.target.value;
  setPlantAttributeSlug('all');
  setPlantTypeSlug(event.target.value);
  
  if(selectedValue == 'all'){
    setPlants(originalPlants);
  } else {
    var newPlants = originalPlants.filter((value) => {
      var found = false;
      value?.plantType?.forEach( (innerValue) => {
        if(innerValue.slug == selectedValue){ found = true; }
      });

      if(found){ return value; }
    });

    setPlants(newPlants);
  }
};

const attributeOnChange = (event) => {
  const selectedValue = event.target.value;
  setPlantTypeSlug('all');
  setPlantAttributeSlug(event.target.value);
  
  if(selectedValue == 'all'){
    setPlants(originalPlants);
  } else {
    var newPlants = originalPlants.filter((value) => {
      var found = false;
      value?.plantAttribute?.forEach( (innerValue) => {
        if(innerValue.slug == selectedValue){ found = true; }
      });

      if(found){ return value; }
    });

    setPlants(newPlants);
  }
};

useEffect(()=>{
  setSearchValue(new URLSearchParams(new URL(window.location.href).search).get('search'));
  setPlantTypeSlug(new URLSearchParams(new URL(window.location.href).search).get('type'));
  setPlantAttributeSlug(new URLSearchParams(new URL(window.location.href).search).get('attribute'));

  async function fetchPlants() {
    if(new URLSearchParams(new URL(window.location.href).search).get('search')){
      const search = new URLSearchParams(new URL(window.location.href).search).get('search')

      setPlantTypeSlug('all');
      setPlantAttributeSlug('all');

      const allPlantList = await fetch(`${process.env.NEXT_PUBLIC_WORDPRESS_API_URL}/wp-json/naturallands/v1/plants/`);
      let allPlants = await allPlantList.json();

      const plantList = await fetch(`${process.env.NEXT_PUBLIC_WORDPRESS_API_URL}/wp-json/naturallands/v1/plants/?search=` + search);
      const plants = await plantList.json();
            
      setOriginalPlants(allPlants);
      setPlants(plants);
    } else {
      const plantList = await fetch(`${process.env.NEXT_PUBLIC_WORDPRESS_API_URL}/wp-json/naturallands/v1/plants/`);
      const plants = await plantList.json();

      var newPlants = [];
      var plantsForSort = [...plants];

      newPlants = plantsForSort.sort( (a, b) => {
        if(a?.scientificName > b?.scientificName){
          return 1;
        }

        if(a?.scientificName < b?.scientificName){
          return -1;
        }

        return 0;
      });

      setOriginalPlants(newPlants);

      if(new URLSearchParams(new URL(window.location.href).search).get('type')){
        let typeValue = new URLSearchParams(new URL(window.location.href).search).get('type');

        var newPlants = plants.filter((value) => {
          var found = false;
          value?.plantType?.forEach( (innerValue) => {
            if(innerValue.slug == typeValue){ found = true; }
          });
  
          if(found){ return value; }
        });
  
        newPlants = newPlants.sort( (a, b) => {
          if(a?.scientificName > b?.scientificName){
            return 1;
          }
  
          if(a?.scientificName < b?.scientificName){
            return -1;
          }
  
          return 0;
        });
      }

      if(new URLSearchParams(new URL(window.location.href).search).get('attribute')){
        let typeValue = new URLSearchParams(new URL(window.location.href).search).get('attribute');

        var newPlants = plants.filter((value) => {
          var found = false;
          value?.plantAttribute?.forEach( (innerValue) => {
            if(innerValue.slug == typeValue){ found = true; }
          });
  
          if(found){ return value; }
        });
  
        newPlants = newPlants.sort( (a, b) => {
          if(a?.scientificName > b?.scientificName){
            return 1;
          }
  
          if(a?.scientificName < b?.scientificName){
            return -1;
          }
  
          return 0;
        });
      }

      setPlants(newPlants);
    }
  }

  fetchPlants();
}, []);

  return (
    <div className='wrap'>
      <Script defer={true}>
          {`(function (w, d, s, l, i) {
                    w[l] = w[l] || []; w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
                    var f = d.getElementsByTagName(s)[0], j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : '';
                    j.async = true; j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl; f.parentNode.insertBefore(j, f);
                })(window, document, 'script', 'dataLayer', 'GTM-KJ842L9');`}
        </Script>
        <Script defer={true}>
          {`!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');fbq('init','1908777585816939');fbq('track','PageView');
        `}
        </Script>
      <YoastSEO
          page={seoData}
          MetaRenderElement={Head}
          meta={<>
            <meta name="MobileOptimized" content="width" />
            <meta name="HandheldFriendly" content="True"/>
            <meta name="viewport" content="width=device-width, initial-scale=1.0, minimum-scale=1.0" />
            <title>Natural Lands</title>
            <link rel="icon" href="/assets/favicon/favicon.ico"></link>
          </>}
        ></YoastSEO>
      <StoneleighHeader header={headerData}></StoneleighHeader>
      <main>
        <div id="content" role="main">
            <div id="plants-header-container" className='container'>
                {
                    headerSubtitle && (
                        <div dangerouslySetInnerHTML={{ __html: headerSubtitle }}></div>
                    )
                }
            </div>
            <div id="plants-filter-container" className='container'>
                <div>
                    <div>
                      <label>plant type</label>
                      <div className="select-wrapper">
                          <select value={plantTypeSlug} onChange={typeOnChange}>
                              <option value="all">all</option>
                              {
                                  plantTypes && plantTypes.length>0 && plantTypes.map((item, index) => (  
                                      <option key={index} value={`${item.slug}`}>
                                        {item.name}
                                      </option>
                                  ))
                              }
                          </select>
                      </div>
                    </div>
                    <div>
                      <label>attribute</label>
                      <div className="select-wrapper">
                          <select value={plantAttributeSlug} onChange={attributeOnChange}>
                              <option value="all">all</option>
                              {
                                  plantAttributes && plantAttributes.length>0 && plantAttributes.map((item, index) => (  
                                      <option key={index} value={`${item.slug}`}>
                                        {item.name}
                                      </option>
                                  ))
                              }
                          </select>
                      </div>
                    </div>
                    <div>
                      <label>search</label>
                      <div id="search-wrapper">
                          <input type="text" placeholder="what are you looking for?" value={searchValue} onKeyUp={plantSearch} onChange={e => setSearchValue(e.target.value)} />
                          <span className="icon-search"></span>
                      </div>
                    </div>
                </div>
            </div>
            <div id="plants-container" className='container'>
                <div>
                    {
                        plants && plants.length > 0 && plants.map((item, index) => ( 
                            <div>
                                <a href={`${item.uri}`}>
                                  {
                                    item.image && (
                                      <div className='image-wrapper'>
                                        <Image
                                            src={`${item.image}`}
                                            layout='fill'
                                            quality={100}
                                            alt={`${item.imageAlt}`}
                                        />
                                      </div>
                                    )
                                  }
                                  <p className='title'>{decodeURIComponent(item.title)}</p>
                                  <p className='name' dangerouslySetInnerHTML={{ __html: item.scientificName }}></p>
                                </a>
                            </div>
                        ))
                    }
                </div>
            </div>
            <CTA
              cta={cta}
            ></CTA>
        </div>
        <Script defer={true}>
            {`(function(d,u,ac){var s=d.createElement('script');s.type='text/javascript';s.src='https://a.omappapi.com/app/js/api.min.js';s.async=true;s.dataset.user=u;s.dataset.account=ac;d.getElementsByTagName('head')[0].appendChild(s);})(document,32897,23154);
    <!-- / OptinMonster -->`}
            </Script>
            <RouteChangeListener/>
      </main>
      <DynamicFooterStoneleigh footer={footerData}></DynamicFooterStoneleigh>
    </div>
  )
}

export async function getStaticProps(){
  const headerData = await client.query({
    query: GET_HEADER_OPTIONS
  });

  const footerData = await client.query({
    query: GET_FOOTER_OPTIONS
  });

  const plantAttributes = await client.query({
      query: GET_PLANT_ATTRIBUTES
  });

  const plantTypes = await client.query({
    query: GET_PLANT_TYPES
});

  const plantOptions = await client.query({
    query: GET_PLANT_OPTIONS
  });

  const plantsSeo = await client.query({
    query: GET_PLANTS
  });

  const plantList = await fetch(`${process.env.NEXT_PUBLIC_WORDPRESS_API_URL}/wp-json/naturallands/v1/plants/`);
  const plants = await plantList.json();

  return {
    props: {
      pageData: {
        footerData: footerData,
        plantAttributes: plantAttributes,
        plantTypes: plantTypes,
        headerData: headerData,
        plantOptions: plantOptions,
        plants: plants,
        plantSeo: plantsSeo
      }
    },
    revalidate: 45,
  }
}